import { useCallback } from 'react';
import { useMutableRef } from '@carnica/utils/hooks';
import { checkIfMessageSent } from "../../../../entities/message/model";
import { useSocketContext } from "../../../../entities/socket/model";
import { SocketStatus } from "../../../../shared/config";
import { useAppDispatch } from "../../../../shared/model";
export var useSubmitHandler = function useSubmitHandler() {
  var _useSocketContext = useSocketContext(),
    socketRef = _useSocketContext.socketRef,
    socketStatus = _useSocketContext.socketStatus;
  var socketStatusRef = useMutableRef(socketStatus);
  var dispatch = useAppDispatch();
  var getIsReadyForSubmit = function getIsReadyForSubmit() {
    return !!socketRef.current && socketStatusRef.current === SocketStatus.open;
  };
  var submitToSocket = useCallback(function (message) {
    var submit = function submit() {
      if (getIsReadyForSubmit()) {
        var _socketRef$current;
        (_socketRef$current = socketRef.current) === null || _socketRef$current === void 0 || _socketRef$current.send(JSON.stringify(message));
      }
    };
    if (getIsReadyForSubmit()) {
      submit();
    } else {
      // Отправляем с задержкой, так как если слишком быстро отправить после открытия чата сокет может еще не быть открытым
      setTimeout(submit, 1000);
    }
  }, [socketStatus]);
  var checkMessageStatus = function checkMessageStatus(message) {
    setTimeout(function () {
      dispatch(checkIfMessageSent(message));
    }, 10000);
  };
  return {
    submitToSocket: submitToSocket,
    checkMessageStatus: checkMessageStatus
  };
};